"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Diversity = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const PartyName_1 = require("../parties/PartyName");
const Resources_1 = require("../../Resources");
class Diversity {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.DIVERSITY;
        this.description = 'Gain 10 M€ if you have 9 or more different tags. Influence counts as unique tags.';
        this.revealedDelegate = PartyName_1.PartyName.SCIENTISTS;
        this.currentDelegate = PartyName_1.PartyName.SCIENTISTS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            if (player.getDistinctTagCount('globalEvent') + turmoil.getPlayerInfluence(player) >= 9) {
                player.addResource(Resources_1.Resources.MEGACREDITS, 10, { log: true, from: this.name });
            }
        });
    }
}
exports.Diversity = Diversity;
//# sourceMappingURL=Diversity.js.map